import { List, Map, Record } from 'immutable';

const ProductRecord = Record({
    campaigns: List(),
    categories: List(),
    companyId: null,
    description: '',
    expiresAt: null,
    id: null,
    keywords: List(),
    listings: List(),
    media: List(),
    metadata: Map(),
    name: '',
    price: '',
    primaryImage: Map({
        id: null,
        title: null,
        type: null,
        url: null,
    }),
    sku: '',
}, 'Product');

function getMediaUrl() {
    return this.getIn(['media', 0, 'url']);
}

ProductRecord.prototype.getMediaUrl = getMediaUrl;

export default ProductRecord;
